module.exports = __webpack_public_path__ + "img/upload-doc.a9120e98.svg";